import { Box, Typography } from '@mui/material'
import FigmaIconFrame from './FigmaIconFrame'
import { MOBILE_MQ, mobileCardTitleSx } from '../../theme/mobileLayout'

export default function FeatureCard({
  title,
  iconSrc,
  iconBgColor = 'rgba(8,39,83,0.12)',
  sx = {},
}) {
  return (
    <Box
      sx={{
        flex: { sm: '1 1 0' },
        minWidth: 0,
        bgcolor: '#fffefa',
        borderRadius: { xs: '16px', lg: '20px' },
        boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.12)',
        p: { xs: '16px', lg: '24px' },
        display: 'flex',
        gap: '20px',
        alignItems: 'center',
        minHeight: { xs: 86, lg: 112 },
        boxSizing: 'border-box',
        ...sx,
      }}
    >
      <FigmaIconFrame
        src={iconSrc}
        bgColor={iconBgColor}
        sx={{
          width: { xs: 52, lg: 64 },
          height: { xs: 52, lg: 64 },
          [MOBILE_MQ]: { width: 52, height: 52 },
        }}
      />
      <Typography
        sx={{
          fontSize: { xs: 16, sm: 18, lg: 22 },
          lineHeight: 'normal',
          fontWeight: 400,
          color: '#111',
          ...mobileCardTitleSx,
          [MOBILE_MQ]: { fontSize: 16 },
        }}
      >
        {title}
      </Typography>
    </Box>
  )
}
